import { render, staticRenderFns } from "./product-sidebar.vue?vue&type=template&id=7f3a7ae7&scoped=true&xmlns%3Av-swiper=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./product-sidebar.vue?vue&type=script&lang=js&"
export * from "./product-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3a7ae7",
  null
  
)

export default component.exports